import React, { useState } from "react";
import { Button, Tooltip, Modal, message as antdMessage } from "antd";
import { AudioOutlined, StopOutlined } from "@ant-design/icons";

function AudioRecorderComponent({ onSend }) {
  const [isRecording, setIsRecording] = useState(false);
  const [mediaRecorder, setMediaRecorder] = useState(null);
  const [audioChunks, setAudioChunks] = useState([]);
  const [audioBlob, setAudioBlob] = useState(null);
  const [audioPreview, setAudioPreview] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      const chunks = [];

      recorder.ondataavailable = (e) => chunks.push(e.data);
      recorder.onstop = () => {
        const blob = new Blob(chunks, { type: "audio/webm" });
        setAudioBlob(blob);
        setAudioPreview(URL.createObjectURL(blob));
        setShowModal(true);
      };

      recorder.start();
      setAudioChunks(chunks);
      setMediaRecorder(recorder);
      setIsRecording(true);
    } catch (err) {
      antdMessage.error("Microphone access denied or error.");
    }
  };

  const stopRecording = () => {
    if (mediaRecorder) {
      mediaRecorder.stop();
      setMediaRecorder(null);
      setIsRecording(false);
    }
  };

  const handleSendAudio = () => {
    if (audioBlob) {
      onSend(audioBlob); 
      setAudioBlob(null);
      setAudioPreview(null);
      setShowModal(false);
    }
  };

  return (
    <>
      <Tooltip title={isRecording ? "Stop Recording" : "Start Recording"}>
        <Button
          icon={isRecording ? <StopOutlined /> : <AudioOutlined />}
          onClick={isRecording ? stopRecording : startRecording}
          type="text"
        />
      </Tooltip>
      <Modal
        open={showModal}
        onCancel={() => setShowModal(false)}
        onOk={handleSendAudio}
        okText="Send"
        cancelText="Cancel"
      >
        <p>Preview your voice message:</p>
        {audioPreview && (
          <audio controls src={audioPreview} className="w-100" />
        )}
      </Modal>
    </>
  );
}
export default AudioRecorderComponent;
